import React, { useEffect, useMemo, useState } from 'react';
import { Alert, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import axios from 'axios';
import Card from '../../../components/Card';
import { useLanguage } from '../../../i18n/LanguageContext';
import apiUrl from '../../../config/api';

const SiteSettings = () => {
  const { t } = useLanguage();
  const text = t.siteSettingsPage;
  const [registrationEnabled, setRegistrationEnabled] = useState(true);
  const [savedValue, setSavedValue] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);

  useEffect(() => {
    axios.get(`${apiUrl}/admin/site-settings`, { headers })
      .then((response) => {
        const enabled = response.data?.registrationEnabled !== false;
        setRegistrationEnabled(enabled);
        setSavedValue(enabled);
      })
      .catch((requestError) => setError(requestError.response?.data?.message || requestError.message))
      .finally(() => setIsLoading(false));
  }, [headers]);

  const saveSettings = async () => {
    setIsSaving(true);
    setError('');
    setSuccess('');
    try {
      const response = await axios.put(
        `${apiUrl}/admin/site-settings`,
        { registrationEnabled },
        { headers }
      );
      const enabled = response.data?.registrationEnabled !== false;
      setRegistrationEnabled(enabled);
      setSavedValue(enabled);
      setSuccess(text.saved);
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <Row>
      <Col xl="8" lg="10">
        <Card className="site-settings-card" data-aos="fade-up">
          <Card.Body>
            <div className="site-settings-header">
              <h3>{text.title}</h3>
              <p>{text.subtitle}</p>
            </div>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success" dismissible onClose={() => setSuccess('')}>{success}</Alert>}
            {isLoading ? (
              <div className="site-settings-loading"><Spinner animation="border" size="sm" /> {text.loading}</div>
            ) : (
              <>
                <div className="site-setting-row">
                  <div>
                    <h5>{text.registrationTitle}</h5>
                    <p>{registrationEnabled ? text.registrationEnabledHelp : text.registrationDisabledHelp}</p>
                  </div>
                  <Form.Check
                    type="switch"
                    id="site-registration-enabled"
                    checked={registrationEnabled}
                    onChange={(event) => {
                      setRegistrationEnabled(event.target.checked);
                      setSuccess('');
                    }}
                    label={registrationEnabled ? text.enabled : text.disabled}
                  />
                </div>
                {!registrationEnabled && <Alert variant="warning" className="mt-3 mb-0">{text.disabledWarning}</Alert>}
                <div className="site-settings-actions">
                  <Button
                    variant="primary"
                    onClick={saveSettings}
                    disabled={isSaving || registrationEnabled === savedValue}
                  >
                    {isSaving ? <><Spinner animation="border" size="sm" /> {text.saving}</> : text.save}
                  </Button>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default SiteSettings;
